module.exports = __webpack_public_path__ + "static/img/returnBox.f58428a4.svg";